export const CLIENT = '/client/v1.0';
export const IDENTITY = '/identity/v1.0';
export const EXPORT = `/export/v1.0`;
export const USER = '/user/v1.0';

export const BILLING = `${CLIENT}/billing`;
export const CLIENT_USERS = `${CLIENT}/users`;
export const CLIENTS = `${CLIENT}/clients`;
export const SESSIONS = `${CLIENT}/sessions`;
export const TARGETS = `${CLIENT}/targets`;
export const BEHAVIORS = `${CLIENT}/behaviors`;
export const CALENDAR = `${CLIENT}/calendar`;
export const SOAP_NOTES = `${CLIENT}/soap-notes`;
export const BRANCHES = `${CLIENT}/branches`;
export const DASHBOARD = `${CLIENT}/dashboard`;
export const INSURANCE_AUTHORIZATION = `${CLIENT}/insurance-authorization`;
export const USERS = `${USER}/users`;
export const USER_SESSION_ALLOCATIONS = `${USER}/user-session-allocations`;
export const CLINICAL_SUPERVISORS = `${USERS}/clinical-supervisors`;
export const TARGETS_ANNOTATIONS = `${TARGETS}/annotations`;
export const TARGETS_GLOBAL_ANNOTATIONS = `${TARGETS}/annotations/global`;
export const BEHAVIORS_ANNOTATIONS = `${BEHAVIORS}/annotations`;
export const BEHAVIORS_GLOBAL_ANNOTATIONS = `${BEHAVIORS}/annotations/global`;
export const CALENDAR_EVENTS = `${CALENDAR}/events`;

export const PROGRAMS = (skillAreaId: string) => `${CLIENT}/skill-areas/${skillAreaId}/programs`;
export const SKILL_AREA = (clientId: string) => `${CLIENTS}/${clientId}/skill-areas`;
export const PROGRAM_TARGET = (programId: string) => `${CLIENT}/programs/${programId}/targets`;
export const CLIENT_BEHAVIORS = (clientId: string) => `${CLIENTS}/${clientId}/behaviors`;
export const CLIENT_SOAP_NOTES = (clientId: string) => `${CLIENTS}/${clientId}/soap-notes`;
export const CLIENT_INSURANCE_AUTHORIZATION = (clientId: string) => `${CLIENTS}/${clientId}/insurance-authorization`;
